
import React from 'react';

import { 
  UserCard,
  UserContext,
} from '../components/user';

export default function Account() {
  const userContext=React.useContext(UserContext);
  return (
    <UserCard user={userContext} />
  );
}